import React from "react";
import Box from "components/Box/Box";
import styles from "./BoxFilter.module.scss";
import { calculateDistance } from "assets/helpers";

class BoxFilter extends React.Component {

    state = {
        open: true,
        loading: true
    };

    getInitialState() {
        return { showResults: false };
    }
    
    componentDidMount() {
        // this simulates an async action, after which the component will render the content
        demoAsyncCall().then(() => this.setState({ loading: false }));
    }   
    
    favoritar = (selectedMkr) => {
        this.props.favoritar(selectedMkr);
    };

    isFavorite = (item) => {
        let existeFavorito = false;
        const { estabelecimentosFavoritos } = this.props;
        for (let i = 0; i < estabelecimentosFavoritos.length; i++) {
            if (estabelecimentosFavoritos[i] === item) {
                existeFavorito = true;
                break;
            }
        }
        return existeFavorito;
    };
    
    Capitalize(str){
        return str.charAt(0).toUpperCase() + str.slice(1);
    }
    
    render() {        
        const { loading } = this.state;
        const { selectedMkr, estabelecimentos, userLocation, setSelectedEstabelecimento } = this.props;

        
        let content = null;

        if(selectedMkr){        
            content =  <Box 
                            item={selectedMkr} 
                            isFavorite={this.isFavorite(selectedMkr)}
                            favoritar ={() => {this.favoritar(selectedMkr)}}
                            userLocation={userLocation}
                            selectedMkr={this.props.selectedMkr}
                            setSelectedEstabelecimento={setSelectedEstabelecimento}
                            estabelecimentosFavoritos={
                                this.props.estabelecimentosFavoritos
                            }      
                            setZoom={this.props.setZoom}                      
                        />
        }
        else if(estabelecimentos){
            let res = [];
            let order =  [ ...estabelecimentos ]

            order.sort(( a, b ) => (calculateDistance({lat: a.LATITUDE, lng: a.LONGITUDE}, userLocation) > calculateDistance({lat: b.LATITUDE, lng: b.LONGITUDE}, userLocation) ) ? 1 : -1  )
            for (let i = 0; i < order.length ; i++) {
                if(i >= 10) break;
                let estabelecimento = order[i];
                res.push(
                    <Box 
                        key={i}
                        item={estabelecimento} 
                        favoritar ={() => {this.favoritar(estabelecimento)}}
                        isFavorite={this.isFavorite(estabelecimento)}
                        userLocation={userLocation}
                        selectedMkr={this.props.selectedMkr}
                        setSelectedEstabelecimento={setSelectedEstabelecimento}
                        estabelecimentosFavoritos={
                            this.props.estabelecimentosFavoritos
                        }                        
                        setZoom={this.props.setZoom}
                    />
                )
            }
            content = res
        } 
        
        if(loading) {
            return (
                <div className="sk-cube-grid">
                    <div className="sk-cube sk-cube1"></div>
                    <div className="sk-cube sk-cube2"></div>
                    <div className="sk-cube sk-cube3"></div>
                    <div className="sk-cube sk-cube4"></div>
                    <div className="sk-cube sk-cube5"></div>
                    <div className="sk-cube sk-cube6"></div>
                    <div className="sk-cube sk-cube7"></div>
                    <div className="sk-cube sk-cube8"></div>
                    <div className="sk-cube sk-cube9"></div>
                </div>
            )
        }
        return (
            <div className={styles.boxFilter}>
                <div className={styles.borderTop}>&nbsp;</div>
                    
                    <div className={styles.boxFilterResult}>
                        <div className={styles.title}>
                            Estabelecimentos próximos
                        </div>
                        {content}
                    </div>
            </div>
        )
    }
}
function demoAsyncCall() {
    return new Promise((resolve) => setTimeout(() => resolve(), 5000));
}

export default BoxFilter;